import React from 'react';
import { RadioGroup, RadioGroupItem } from '@/components/radix/radio-group';
import { Label } from '../radix/label';

interface RadioButtonProps {
    tag: string;
    options: {
        value: string;
        label: string | { [key: string]: string };
    }[];
    orientation: 'horizontal' | 'vertical';
    locale: string;
    defaultValue: string;
    onChange: (value: string) => void;
}

const RadioButton: React.FC<RadioButtonProps> = props => {
    const { options, tag, orientation, locale, defaultValue, onChange } = props;
    const [value, setValue] = React.useState<string>(defaultValue);

    const onChangeValue = (value: string) => {
        setValue(value);
        onChange(value);
    };

    return (
        <RadioGroup
            className={`w-full mt-1 mb-3 ${
                orientation === 'horizontal'
                    ? 'flex flex-row space-x-2 md:space-x-3'
                    : 'flex flex-col space-y-1'
            }`}
            defaultValue={value}
            onValueChange={onChangeValue}
        >
            {options.map((item, index) => (
                <div className="flex items-center space-x-2" key={index}>
                    <RadioGroupItem
                        id={`inlineRadio-${tag}-${index}`}
                        value={item.value}
                    />
                    <Label htmlFor={`inlineRadio-${tag}-${index}`}>
                        {typeof item.label === 'string'
                            ? item.label
                            : item.label[locale]}
                    </Label>
                </div>
            ))}
        </RadioGroup>
    );
};

export default RadioButton;
